<template>
    <div v-html="contentBlock"></div>
</template>

<script>
import FeApiService from "@/assets/js/FeApiService";
const apiService = new FeApiService();

export default {
  data() {
    return {
        contentBlock: "",
    };
  },
  props: {
    name: {
      type: String
    },
  },
  mounted() {
    apiService
        .getContentBlockDetails( this.name )
        .then(request => this.contentBlockSuccessful(request))
        .catch(err => this.contentBlockFailed(err));
  },
  methods: {
    contentBlockSuccessful(request) {
      (this.contentBlock = request.content);
    },
    contentBlockFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true
      });
    }   
  }
};
</script>